import {Icon, LinkIconWrapper} from "./styles.js";

const SocialMediaIcon = ({target = "", alt, src, ...props}) => {
  return (
    <LinkIconWrapper target={target} alt={alt} {...props}>
      <Icon src={src} alt="social media icon" loading="lazy" />
    </LinkIconWrapper>
  );
};

export default SocialMediaIcon;
